export enum AuthenticationType {
    Badge = 'Badge',
    Credentials = 'Credentials',
    Msal = 'Msal'
}
